import { FC, useCallback, useEffect, useRef } from 'react'

import { Direction } from 'components/page/RatingWave/Rating.types'
import { useModalOpened } from 'hooks/useModalOpened'

export const KeyboardControl: FC<{
  onHandleKeyboard: (action: Direction) => void
}> = ({ onHandleKeyboard }) => {
  const hasModal = useModalOpened()
  const keyPressRef = useRef(false)

  const handleKeyDown = useCallback(
    (event: KeyboardEvent) => {
      if (!hasModal && !keyPressRef.current) {
        switch (event.code) {
          case 'ArrowLeft':
            keyPressRef.current = true
            onHandleKeyboard(Direction.left)
            break
          case 'ArrowRight':
            keyPressRef.current = true
            onHandleKeyboard(Direction.right)
            break

          default:
            break
        }
      }
      /**
       * Запрещаем прокрутку страницы по нажатию на пробел
       * Если открыт модал.
       */
      if (hasModal && event.code === 'Space') {
        event.preventDefault()
      }
    },
    [hasModal, onHandleKeyboard]
  )

  useEffect(() => {
    // Добавляем обработчик события
    window.addEventListener('keydown', handleKeyDown)

    // Убираем обработчик события при размонтировании
    return () => {
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [handleKeyDown])

  return null
}
